import { ePageBaseStatus } from '../../../models/ePageBaseStatus';
import { ITheoDoiRCActionTypes } from './../../action-types/theo-doi-rc/ITheoDoiRCActionTypes';
import { ITheoDoiRCReducer } from './../../page-state-model/theo-doi-rc/ITheoDoiRCReducer';
const iniState: ITheoDoiRCReducer = {
    filter: {
        dm_lop_id: 0,
        hoc_ky: 0,
        nam_hoc: "",
        dm_khoi_id: 0,
        sis_giaidoan_id: 0,
        pl_lopbomon_id: 0,
        ts_hocsinh_id: 0
    },
    status: ePageBaseStatus.is_not_initialization,
    report_cards: []
}
export const theoDoiRCReducer = (
    state: ITheoDoiRCReducer=iniState,
    action: ITheoDoiRCActionTypes
): ITheoDoiRCReducer => {
    switch (action.type) {
        case "THEO_DOI_RC_CHANGE_FILTER":
            return {
                ...state,
                filter: action.payload
            }
        case "THEO_DOI_RC_LOAD_START":
            return {
                ...state,
                status: ePageBaseStatus.is_loading
            }
        case "THEO_DOI_RC_LOAD_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                report_cards: action.payload
            }
        case "THEO_DOI_RC_LOAD_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
                report_cards: []
            }
        case "THEO_DOI_RC_DELETE_START":
            return {
                ...state,
                status: ePageBaseStatus.is_deleting,
            }
        case "THEO_DOI_RC_DELETE_ERROR":
            return {
                ...state,
                status: ePageBaseStatus.is_completed,
            }
        case "THEO_DOI_RC_DELETE_SUCCESS":
            return {
                ...state,
                status: ePageBaseStatus.is_need_reload,
            }

        default:
            return state;
    }
}